


































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MelosPodcast } from '@/services/api.service';
import MelosInput from '@/components/MelosInput.vue';
import MelosButton from '@/components/MelosButton.vue';
import MelosButtonSet from '@/components/MelosButtonSet.vue';
import _ from 'lodash';

@Component({
  components: {
    MelosInput,
    MelosButton,
    MelosButtonSet,
  },
})
export default class PodcastDetails extends Vue {
  private tags: string[] = [];
  private originalTags: string[] = [];
  private debouncedTagChangeHandler: any = _.debounce(this.onTagsChanged, 1000);
  private debouncedPodcastChangeHandler: any = _.debounce(this.updatePodcastData, 1000);
  private updateEventCount = 0;
  private coverDateString = new Date().getTime();

  private async mounted() {
    this.tags = this.getTags();
    this.originalTags = [ ...this.tags ];
    if (this.podcastData === undefined) {
      await this.fetchContent();
    }
  }

  private get podcastData(): MelosPodcast {
    return this.$store.state.ownedPodcasts.find((podcast: MelosPodcast) => {
      return podcast._id === this.$route.params.podcastId;
    });
  }

  private get podcastList(): MelosPodcast[] {
    return this.$store.state.ownedPodcasts.filter((podcast: MelosPodcast) => {
      return (this.$store.state.checkedItems || []).includes(podcast.id);
    });
  }

  private get token(): string {
    return this.$store.state.session?.token || '';
  }

  private async fetchContent() {
    const ownedStations = (await this.$apiService.getStations())
   .filter((station) => station.owner === this.$store.state.session?.userId);
    const ownedPodcasts = await this.$apiService.getPodcasts();
    const ownedTracks = await this.$apiService.getTracks();
    this.$store.commit('setOwnedStations', ownedStations);
    this.$store.commit('setOwnedPodcasts', ownedPodcasts);
    this.$store.commit('setOwnedTracks', ownedTracks);
    this.tags = this.getTags();
    this.originalTags = [ ...this.tags ];
  }

  private async addNewTag() {
    this.tags.push('');
  }

  private async removeTag(index: number, tag: string) {
    this.tags.splice(index, 1);
    for (const podcast of (this.podcastList || [])) {
      (podcast.tags as string[]).splice(index, 1);
      this.$apiService.updatePodcast(podcast);
    }
  }

  private getTags(): string[] {
    return (this.podcastData?.tags as string[]) || [];
  }

  @Watch('podcastData.title')
  private async handlePodcastUpdate() {
    if (this.updateEventCount < 2) {
      this.updateEventCount ++;
      return;
    }
    return this.debouncedPodcastChangeHandler();
  }

  private async updatePodcastData() {
    if (this.podcastData !== undefined) {
      return this.$apiService.updatePodcast(this.podcastData);
    } else {
      for (const podcast of this.podcastList) {
        this.$apiService.updatePodcast(podcast);
      }
    }
  }

  @Watch('tags')
  private async handleTagChange() {
    if (this.updateEventCount < 2) {
      this.updateEventCount ++;
      return;
    }
    return this.debouncedTagChangeHandler();
  }

  private async onTagsChanged() {
    if (this.podcastData !== undefined) {
      this.podcastData.tags = this.tags;
      return this.$apiService.updatePodcast(this.podcastData);
    } else if (this.tags.length === this.originalTags.length) {
      // Find tag that changed it's value
      const updatedTagIndex = this.originalTags.findIndex((tag) => !this.tags.includes(tag));
      const oldTagValue = this.originalTags[updatedTagIndex];
      const newTagValue = this.tags[updatedTagIndex];
      for (const podcast of this.podcastList) {
        const tagIndex = (podcast.tags as string[]).findIndex((tag: string) => tag === oldTagValue);
        (podcast.tags as string [])[tagIndex] = newTagValue;
        this.$apiService.updatePodcast(podcast);
      }
    }
    this.originalTags = [ ...this.tags ];
  }

  private getFormattedTime(time: number): string {
    const minutes = String(Math.round(time / 60)).padStart(2, '0');
    const seconds = String(Math.round(time % 60)).padStart(2, '0');
    return `${minutes}:${seconds}`;
  }
}

